import { Listbox } from "@headlessui/react"
import { Fragment } from "react"
import DropDownIcon from "../../../../../../components/svg/DropDownIcon"

export default function ReviseMeta({
  selectedQuestionLocation,
  selectedAdmissionTest,
  setSelectedAdmissionTest,
  admissionTests,
  selectedSectionNumber,
  setSelectedSectionNumber,
  getSectionNumberByAdmissionTestId,
  getTopicsBySubjectId,
  sectionNumbers,
  selectedSubject,
  setSelectedSubject,
  subjects,
  selectedTopic,
  setSelectedTopic,
  topics,
  onBlur
}) {
  return (
    <>
      {selectedQuestionLocation.name === "Revise" && (
        <>
          <div className="flex flex-col items-start gap-1">
            <div className="flex w-full items-center justify-between px-3">
              <label
                htmlFor="questionStyle"
                className="text-base text-neutral-12"
              >
                Admission Test
              </label>
            </div>
            <Listbox
              as="div"
              className="relative w-full"
              value={selectedAdmissionTest}
              onChange={value => {
                setSelectedAdmissionTest(value)
                getSectionNumberByAdmissionTestId(value.id)
              }}
              name="questionLocation"
              id="questionLocation"
              onBlur={() => {
                onBlur({
                  admissionTestId: selectedAdmissionTest.id
                })
              }}
            >
              {({ open }) => (
                <>
                  <Listbox.Button as={Fragment}>
                    <button
                      id="admissionTest"
                      className={`subtitle-2 relative flex w-full items-center justify-between rounded-lg
                      px-4 py-2.5  focus:outline-neutral-2 ${
                        open
                          ? "border-2 border-primary"
                          : "border border-neutral-2"
                      }`}
                    >
                      <div className="flex w-full items-center justify-between">
                        <span>
                          {selectedAdmissionTest.name
                            ? selectedAdmissionTest.name.length > 23
                              ? selectedAdmissionTest.name.slice(0, 23) + " ..."
                              : selectedAdmissionTest.name
                            : "Select Admission Test"}
                        </span>
                        <DropDownIcon rotate={`${open ? 180 : 0}`} />
                      </div>
                    </button>
                  </Listbox.Button>
                  <Listbox.Options
                    as="ul"
                    className="top-13 shadow-5 curriculum-scroll absolute z-10 flex max-h-60 w-full flex-col items-start gap-4 overflow-auto rounded-md bg-white px-5 py-4"
                  >
                    {admissionTests?.data?.data &&
                      admissionTests.data.data.map(location => (
                        <Listbox.Option
                          key={location.id}
                          value={location}
                          className="flex w-full cursor-pointer justify-start"
                        >
                          {location.name}
                        </Listbox.Option>
                      ))}
                  </Listbox.Options>
                </>
              )}
            </Listbox>
          </div>

          <div className="flex flex-col items-start gap-1">
            <div className="flex w-full items-center justify-between px-3">
              <label
                htmlFor="questionStyle"
                className="text-base text-neutral-12"
              >
                Section Number
              </label>
            </div>
            <Listbox
              as="div"
              className={`relative w-full ${
                selectedAdmissionTest.id
                  ? "cursor-pointer"
                  : "cursor-not-allowed"
              }`}
              value={selectedSectionNumber}
              onChange={setSelectedSectionNumber}
              name="questionLocation"
              id="questionLocation"
              onBlur={() => {
                onBlur({
                  sectionNumberId: selectedSectionNumber.id
                })
              }}
            >
              {({ open }) => (
                <>
                  {/* Render a `Fragment` instead of a `button` */}
                  <Listbox.Button as={Fragment}>
                    <button
                      id="admissionTest"
                      className={`subtitle-2 relative flex w-full items-center justify-between rounded-lg
                      px-4 py-2.5  focus:outline-neutral-2 ${
                        open
                          ? "border-2 border-primary"
                          : "border border-neutral-2"
                      } ${
                        selectedAdmissionTest.id
                          ? "cursor-pointer"
                          : "pointer-events-none cursor-not-allowed"
                      }`}
                    >
                      <div className="flex w-full items-center justify-between">
                        <span>
                          {selectedSectionNumber.sectionNo
                            ? selectedSectionNumber.sectionNo
                            : "Select Section Number"}
                        </span>
                        <DropDownIcon rotate={`${open ? 180 : 0}`} />
                      </div>
                    </button>
                  </Listbox.Button>
                  <Listbox.Options
                    as="ul"
                    className="top-13 shadow-5 curriculum-scroll absolute z-10 flex max-h-60 w-full flex-col items-start gap-4 overflow-auto rounded-md bg-white px-5 py-4"
                  >
                    {sectionNumbers?.data?.data &&
                      sectionNumbers.data.data.map(location => (
                        <Listbox.Option
                          key={location.id}
                          value={location}
                          className="flex w-full cursor-pointer justify-start"
                        >
                          {location.sectionNo}
                        </Listbox.Option>
                      ))}
                  </Listbox.Options>
                </>
              )}
            </Listbox>
          </div>

          <div className="flex flex-col items-start gap-1">
            <div className="flex w-full items-center justify-between px-3">
              <label
                htmlFor="questionStyle"
                className="text-base text-neutral-12"
              >
                Subject
              </label>
            </div>
            <Listbox
              as="div"
              className="relative w-full"
              value={selectedSubject}
              onChange={value => {
                setSelectedSubject(value)
                getTopicsBySubjectId(value.id)
              }}
              name="selectedSubject"
              id="selectedSubject"
              onBlur={() => {
                onBlur({
                  subjectId: selectedSubject.id
                })
              }}
            >
              {({ open }) => (
                <>
                  {/* Render a `Fragment` instead of a `button` */}
                  <Listbox.Button as={Fragment}>
                    <button
                      id="admissionTest"
                      className={`subtitle-2 relative flex w-full items-center justify-between rounded-lg
                      px-4 py-2.5  focus:outline-neutral-2 ${
                        open
                          ? "border-2 border-primary"
                          : "border border-neutral-2"
                      }`}
                    >
                      <div className="flex w-full items-center justify-between">
                        <span>
                          {selectedSubject.name
                            ? selectedSubject.name
                            : "Select Subject Name"}
                        </span>
                        <DropDownIcon rotate={`${open ? 180 : 0}`} />
                      </div>
                    </button>
                  </Listbox.Button>
                  <Listbox.Options
                    as="ul"
                    className="top-13 shadow-5 curriculum-scroll absolute z-10 flex max-h-60 w-full flex-col items-start gap-4 overflow-auto rounded-md bg-white px-5 py-4"
                  >
                    {subjects?.data?.data &&
                      subjects.data.data.subjects.map(location => (
                        <Listbox.Option
                          key={location.id}
                          value={location}
                          className="flex w-full cursor-pointer justify-start"
                        >
                          {location.name}
                        </Listbox.Option>
                      ))}
                  </Listbox.Options>
                </>
              )}
            </Listbox>
          </div>

          <div className="flex flex-col items-start gap-1">
            <div className="flex w-full items-center justify-between px-3">
              <label
                htmlFor="questionStyle"
                className="text-base text-neutral-12"
              >
                Topic
              </label>
            </div>
            <Listbox
              as="div"
              className={`relative w-full ${
                selectedSubject.id ? "cursor-pointer" : "cursor-not-allowed"
              }`}
              value={selectedTopic}
              onChange={setSelectedTopic}
              name="questionLocation"
              id="questionLocation"
              onBlur={() => {
                onBlur({
                  topicId: selectedTopic.id
                })
              }}
            >
              {({ open }) => (
                <>
                  {/* Render a `Fragment` instead of a `button` */}
                  <Listbox.Button as={Fragment}>
                    <button
                      id="admissionTest"
                      className={`subtitle-2 relative flex w-full items-center justify-between rounded-lg px-4 py-2.5  focus:outline-neutral-2 ${
                        open
                          ? "border-2 border-primary"
                          : "border border-neutral-2"
                      } ${
                        selectedSubject.id
                          ? "cursor-pointer"
                          : "pointer-events-none cursor-not-allowed"
                      }`}
                    >
                      <div className="flex w-full items-center justify-between">
                        <span>
                          {selectedTopic.name
                            ? selectedTopic.name
                            : "Select Topic"}
                        </span>
                        <DropDownIcon rotate={`${open ? 180 : 0}`} />
                      </div>
                    </button>
                  </Listbox.Button>
                  <Listbox.Options
                    as="ul"
                    className="top-13 shadow-5 curriculum-scroll absolute z-10 flex max-h-60 w-full flex-col items-start gap-4 overflow-auto rounded-md bg-white px-5 py-4"
                  >
                    {topics?.data?.data &&
                      topics.data.data.map(location => (
                        <Listbox.Option
                          key={location.id}
                          value={location}
                          className="flex w-full cursor-pointer justify-start"
                        >
                          {location.name}
                        </Listbox.Option>
                      ))}
                  </Listbox.Options>
                </>
              )}
            </Listbox>
          </div>
        </>
      )}
    </>
  )
}
